import { Anchor, Paragraph } from '@zillow/constellation-10';
import Bullet from '../../Bullet';
import Timestamp from '../../Timestamp';

type Props = {
  ctaText?: string;
  message: string;
  messageDateMs: string;
  url?: string;
};

export default function LowPrioritySystemMessage({ ctaText, message, messageDateMs, url }: Props): JSX.Element {
  const shouldShowCta = ctaText && url;
  const hasMessageDateMs = !!messageDateMs;

  return (
    <Paragraph textStyle="body-xs" css={{ textAlign: 'center' }}>
      <span>{message}</span>
      {shouldShowCta && (
        <>
          <span> &nbsp; </span>
          <Anchor href={url} target="_blank" css={{ whiteSpace: 'nowrap' }}>
            {ctaText}
          </Anchor>
        </>
      )}
      {hasMessageDateMs && (
        <>
          <Bullet />
          <Timestamp color="text.neutral" messageDateMs={messageDateMs} />
        </>
      )}
    </Paragraph>
  );
}
